import { useCallback } from "react";
import _isNumeric from "lodash/isFinite";

import { TextInput, TextInputPublicProps } from "./text-input";
import { isNumeric } from "../services";

type Props<N extends string> = Omit<
  TextInputPublicProps<N>,
  "onChange" | "value"
> & {
  value: number | null;
  onChange: (name: N, value: number | null) => void;
};

export function NumberInput<N extends string>({
  disabled = false,
  name,
  onChange,
  value,
  ...rest
}: Props<N>) {
  // Handlers
  const handleChange = useCallback(
    (_name: N, newValue: string | null) => {
      onChange(
        _name,
        newValue !== null && isNumeric(newValue) ? parseFloat(newValue) : null
      );
    },
    [onChange]
  );

  // Render
  return (
    <TextInput
      {...rest}
      name={name}
      onChange={handleChange}
      value={value === null ? "" : `${value}`}
    />
  );
}
